import { Icon, IconProps } from "../";

export const MicIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 15.4743 16.1249 18.3339 12.75 18.707V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V18.707C7.87513 18.3339 5.25 15.4743 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25C6.41421 11.25 6.75 11.5858 6.75 12C6.75 14.8995 9.10051 17.25 12 17.25C14.8995 17.25 17.25 14.8995 17.25 12C17.25 11.5858 17.5858 11.25 18 11.25ZM12 2.5C13.6569 2.5 15 3.84315 15 5.5V12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12V5.5C9 3.84315 10.3431 2.5 12 2.5Z" />
    </Icon>
  );
};
